/**
 * Constants Index
 * 全ての定数ファイルを統一エクスポート
 */

export * from './tableConstants';
export * from './contentProperty';
export * from './forecastAccuracy';

// 上記以外の定数
export const GET_FORECAST_ACCURACY_HISTORY_PERIOD = 12; // APIに送るPeriodは12ヶ月分固定
export const MAX_DISPLAY_COMBINED_ORDER_ITEMS = 7;
export const MAX_DISPLAY_COMBINED_ORDER_ERROR_MESSAGE = 2;
